import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResourcesRefurbishment41_5bTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResourcesRefurbishment41_5b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_RESOURCES_REFURBISHMENT") || "Surplus resources"}
        subDescription={t("SURPLUS_RESOURCES_REFURBISHMENT_41_5B_DESC") || "These are the wastes and removed materials generated during the refurbishment process, such as old parts or stripped coatings. They must be collected and treated through recycling, recovery, or disposal."}
        isNormal={true}
        number={"41.5b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-refurbishment-41-5b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResourcesRefurbishment41_5bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResourcesRefurbishment41_5b;

